import React from "react";
import alertMessageManager from "../../../services/managers/alert-message";

class AlertMessage extends React.Component {
  componentDidUpdate() {
    // Hide the Alert upon any event on the screen
    alertMessageManager.hide(this.props.id);
  }

  render() {
    return (
      <div
        id={this.props.id}
        className={"alert js-alert is-closeable " + (this.props.whichAlert.toUpperCase() === "ERROR" ? "alert--error" : "alert--success")}
        role="alert">
        <div className="alert__icon">
          {this.props.whichAlert.toUpperCase() === "ERROR" ? (
            <i className="fa fa-ban icon--medium" aria-hidden="true" />
          ) : (
            <i class="fa fa-check icon--medium" aria-hidden="true" />
          )}
        </div>
        <div className="alert__heading">
          <span className="alert-message-text" />
        </div>
        <button className="alert__close btn btn--transparent" onClick={() => alertMessageManager.hide(this.props.id)}>
          <i className="fa fa-times-circle-o alert__close__icon pull-right" aria-hidden="true" />
        </button>
      </div>
    );
  }
}

export default AlertMessage;



// WEBPACK FOOTER //
// ./src/components/Common/AlertMessage/AlertMessage.js